import Label from "components/Label/Label";
import { UserValues } from "containers/AccountPage/AccountPage";
import { AuthContext } from "context/AuthContext";
import React, { FC, useContext, useEffect } from "react";
import { UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import Radio from "shared/Radio/Radio";
import Select from "shared/Select/Select";

interface Props {
  isActive: boolean;
  currentUser: any
  onCloseActive: () => void;
  onOpenActive: () => void;
  onRegister: UseFormRegister<UserValues>
  onHandleChangeInput: (e:any) => void;
}

const ShippingAddress: FC<Props> = ({
  isActive,
  currentUser,
  onCloseActive,
  onOpenActive,
  onRegister,
  onHandleChangeInput,
}) => {

  const { connected, user, afterLogin } = useContext(AuthContext);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!localStorage.getItem("access_token") && !sessionStorage.getItem("access_token")) {
       history.push("/");
    }
  });

  const renderShippingAddress = () => {
    return (
      <div className="border border-slate-200 dark:border-slate-700 rounded-xl ">
        <div className="p-6 flex flex-col sm:flex-row items-start">
          <span className="hidden sm:block">
            <svg
              className="w-6 h-6 text-slate-700 dark:text-slate-400 mt-0.5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.1401 15.0701V13.11C12.1401 10.59 14.1801 8.54004 16.7101 8.54004H18.6701"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.62012 8.55005H7.58014C10.1001 8.55005 12.1501 10.59 12.1501 13.12V13.7701V17.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.14008 6.75L5.34009 8.55L7.14008 10.35"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.8601 6.75L18.6601 8.55L16.8601 10.35"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>

          <div className="sm:ml-8">
            <h3 className=" text-slate-700 dark:text-slate-300 flex ">
              <span className="uppercase">{t("shipping_address")}</span>
              <svg
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.5"
                stroke="currentColor"
                className="w-5 h-5 ml-3 text-slate-900 dark:text-slate-100"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 12.75l6 6 9-13.5"
                />
              </svg>
            </h3>
            <div className="font-semibold mt-1 text-sm">
              <span className="">
              {user?.city}  {user?.address}
              </span>
            </div>
          </div>
          <ButtonSecondary
            sizeClass="py-2 px-4 "
            fontSize="text-sm font-medium"
            className="bg-slate-50 dark:bg-slate-800 mt-5 sm:mt-0 sm:ml-auto !rounded-lg"
            onClick={onOpenActive}
          >
            {t("change")}
          </ButtonSecondary>
        </div>
        <div
          className={`border-t border-slate-200 dark:border-slate-700 px-6 py-7 space-y-4 sm:space-y-6 ${
            isActive ? "block" : "hidden"
          }`}
        >
          {/* ============ */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
            <div>
              <Label className="text-sm">{t("first_name")}</Label>
              <Input className="mt-1.5" value={currentUser?.first_name} {...onRegister("first_name")} onChange={onHandleChangeInput}/>
            </div>
            <div>
              <Label className="text-sm">{t("last_name")}</Label>
              <Input className="mt-1.5" value={currentUser?.last_name} {...onRegister("last_name")} onChange={onHandleChangeInput} />
            </div>
          </div>

          {/* ============ */}
          <div className="sm:flex space-y-4 sm:space-y-0 sm:space-x-3">
            <div className="flex-1">
              <Label className="text-sm">{t("address")}</Label>
              <Input
                className="mt-1.5"
                placeholder=""
                value={currentUser?.address} 
                {...onRegister("address")} 
                onChange={onHandleChangeInput} 
                type={"text"}
              />
            </div>
            {/* <div className="sm:w-1/3">
              <Label className="text-sm">Apt, Suite *</Label>
              <Input className="mt-1.5" defaultValue="55U - DD5 " />
            </div> */}
          </div>

          {/* ============ */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
            <div>
              <Label className="text-sm">{t("city")}</Label>
              <Input className="mt-1.5" value={currentUser?.city} {...onRegister("city")} onChange={onHandleChangeInput}  />
            </div>
            <div>
              <Label className="text-sm">{t("country")}</Label>
              <Input className="mt-1.5" value={currentUser?.country} {...onRegister("country")} onChange={onHandleChangeInput}  />
            </div>
          </div>

          <div className="max-w-lg">
            <Label className="text-sm">{t("phone")}</Label>
            <Input className="mt-1.5" value={currentUser?.phone} type={"tel"}  {...onRegister("phone")} onChange={onHandleChangeInput}/>
          </div>
          <div className="max-w-lg">
            <Label className="text-sm">{t("email")}</Label>
            <Input className="mt-1.5" type={"email"} value={currentUser?.email} {...onRegister("email")} onChange={onHandleChangeInput}/>
          </div>

          {/* ============ */}
{/*           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
            <div>
              <Label className="text-sm">State/Province</Label>
              <Input className="mt-1.5" defaultValue="Texas" />
            </div>
            <div>
              <Label className="text-sm">Postal code</Label>
              <Input className="mt-1.5" defaultValue="2500 " />
            </div>
          </div> */}

          {/* ============ */}
{/*           <div>
            <Label className="text-sm">Address type</Label>
            <div className="mt-1.5 grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
              <Radio
                label={`<span class="text-sm font-medium">Home <span class="font-light">(All Day Delivery)</span></span>`}
                id="Address-type-home"
                name="Address-type"
                defaultChecked
              />
              <Radio
                label={`<span class="text-sm font-medium">Office <span class="font-light">(Delivery <span class="font-medium">9 AM - 5 PM</span>)</span> </span>`}
                id="Address-type-office"
                name="Address-type"
              />
            </div>
          </div> */}

          {/* ============ */}
          <div className="flex flex-col sm:flex-row pt-6">
            <ButtonPrimary
              className="sm:!px-7 shadow-none"
              onClick={onCloseActive}
            >
              {t("Save_shipping")}
            </ButtonPrimary>
            <ButtonSecondary
              className="mt-3 sm:mt-0 sm:ml-3"
              onClick={onCloseActive}
            >
              {t("cancel")}
            </ButtonSecondary>
          </div>
        </div>
      </div>
    );
  };
  return renderShippingAddress();
};

export default ShippingAddress;
